import { createService } from '@betty/toolkit/api';
import {
  ShopItemPurchaseResponseSchema,
  ShopItemsResponseSchema,
  ShopSalesResponseSchema,
} from './ShopService.schemas';

export default createService(
  {
    getItems: {
      method: 'GET',
      url: '/store/items',
      responseSchema: ShopItemsResponseSchema,
    },
    purchaseItem: {
      method: 'POST',
      url: ({ id }: { id: number }) => `/store/items/${id}`,
      responseSchema: ShopItemPurchaseResponseSchema,
    },
    getSales: {
      method: 'GET',
      url: '/store/sales',
      responseSchema: ShopSalesResponseSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
